import type { CustomerUpcomingAction } from "@repo/app-types/entities/performanceCustomer";
import { resolveNextActionTimestamp } from "@repo/app-types/entities/teammatePerformanceSummary";
import type { CustomerTimelineRow } from "@repo/ui/customerTimeline/customerTimeline";
import { CustomerTimelineRowDetails } from "@repo/ui/customerTimeline/customerTimelineRowDetails";
import { IconClock } from "@tabler/icons-react";
import { PH_MASK_CLASS } from "../../analytics/sessionRecordingMasking.js";
import {
  formatCallActivityTimestamp,
  nextActionLabel,
  nextActionTimePrefix,
} from "../../teammatePerformance/callActivityColumns.js";
import {
  buildCustomerTimelineParticipant,
  renderTrailingText,
  type OpenCustomerInteraction,
} from "./timelineRowHelpers.js";

export function buildUpcomingActionRowId(
  action: CustomerUpcomingAction,
): string {
  return `upcoming:${action.grading_id}`;
}

/**
 * The timeline row for a voice agent's next action. Its time is in the
 * company's timezone, like the interaction's banner.
 */
export function buildUpcomingActionRow(
  action: CustomerUpcomingAction,
  openInteraction: OpenCustomerInteraction,
  timezone: string,
): CustomerTimelineRow {
  const { next_action: nextAction } = action;
  const timestamp = resolveNextActionTimestamp(nextAction);
  const timeLabel = formatCallActivityTimestamp(timestamp, timezone);
  const timePrefix = nextActionTimePrefix[nextAction.type];

  return {
    id: buildUpcomingActionRowId(action),
    dateTime: timestamp,
    dateLabel: timeLabel,
    isUpcoming: true,
    icon: <IconClock className="size-4" />,
    content: (
      <div className={PH_MASK_CLASS}>
        <CustomerTimelineRowDetails
          title={nextActionLabel[nextAction.type]}
          trailingAccessory={
            timePrefix && renderTrailingText(`${timePrefix}${timeLabel}`)
          }
          participants={[buildCustomerTimelineParticipant(action.teammate)]}
          onOpen={() => openInteraction(action.grading_id)}
        />
      </div>
    ),
  };
}
